import { reactive } from '@/core/reactive/reactive';
import { LoginClient } from '@/core/reactive/services/sdk';
import { LoginConfig } from '@/core/config';

export const LoginService = reactive.service(
  'login',
  LoginClient,
)(Service => new Service(LoginConfig.current?.api?.host ?? ''));

export const LoginServiceReactor = LoginService.reactor('loginServiceReactor', {
  success: () => {},
});
